import { render, staticRenderFns } from "./CreateAssetTask.vue?vue&type=template&id=2164f9a7"
import script from "./CreateAssetTask.vue?vue&type=script&lang=js"
export * from "./CreateAssetTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2164f9a7')) {
      api.createRecord('2164f9a7', component.options)
    } else {
      api.reload('2164f9a7', component.options)
    }
    module.hot.accept("./CreateAssetTask.vue?vue&type=template&id=2164f9a7", function () {
      api.rerender('2164f9a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/CreateAssetTask.vue"
export default component.exports